import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  GatsbyImage,
  getImage,
  Link,
  React
};